import { combineReducers } from 'redux'
import { reducer as homeReducer } from '@/pages/Home/store'
import newsReducer from '@/pages/News/store/reducer'
import produce, { enableES5 } from 'immer'
import { StoreState } from './typings'

enableES5()
const defaultState: StoreState = {
  menuList: [
    {
      name: '联系我们',
      path: '/contact',
      children: [],
    },
  ],
}

const common = (state: StoreState = defaultState): StoreState =>
  produce(state, () => {})

const rootReducer = combineReducers({
  home: homeReducer,
  news: newsReducer,
  common,
})

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
